import * as api from './api'
import JSEncrypt from 'jsencrypt';
import {parseBigInt} from 'jsencrypt/lib/lib/jsbn/jsbn'
import Vue from "vue";

// 公钥
const publicKey = '-----BEGIN PUBLIC KEY-----\n' +
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC420gVEL3w2eSm5IYwdZIeirt7\n' +
  'CPlTA9nthSOZfAZ3Fsg+GOuIJhWMecOkKPAxN2vuR4CRRw3lowF8zahhWKdneEIH\n' +
  'VgtdUpUhDw7mjwZZnoV+V7bKDFotZGYVyTlGDT7p/8/Q/ChONIWmKzozgEvfyHMu\n' +
  'Kxtu82o5zbzm1mIDRQIDAQAB\n' +
  '-----END PUBLIC KEY-----';

const privateKey = '-----BEGIN RSA PRIVATE KEY-----\n' +
  '-----END RSA PRIVATE KEY-----'

/**
 * @description RSA 加密
 * @param {string} data
 * @return {string}
 */
export function encrypt(data) {
  const encrypt = new JSEncrypt();
  console.log(privateKey)
  encrypt.setPrivateKey(privateKey);

  return encrypt.encrypt(data);
}


function pkcs1unpad2(d, n) {
  let b = d.toByteArray()
  let i = 0
  while (i < b.length && b[i] === 0) {
    ++i
  }

  ++i
  while (b[i] !== 0) {
    if (++i >= b.length) {
      return null
    }
  }
  let ret = ''
  while (++i < b.length) {
    let c = b[i] & 255
    if (c < 128) { // utf-8 decode
      ret += String.fromCharCode(c)
    } else if ((c > 191) && (c < 224)) {
      ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63))
      ++i
    } else {
      ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63))
      i += 2
    }
  }
  return ret
}

/**
 * @description RSA 解密
 * @param {string} data
 * @return {string}
 */
export function decrypt(data, publicKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  // 不支持公钥解密
  // 自定义解析方法支持公钥解析
  const rsaKey = encrypt.getKey()
  rsaKey.decrypt = function (ctext) {
    let c = parseBigInt(ctext, 16)
    let m = this.doPublic(c)
    if (m == null) {
      return null
    }
    return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3)
  }
  return encrypt.decrypt(data)
}


/**
 * 复杂对象的深度比较，可用于数组
 * @param {*} x
 * @param {*} y
 */
export function deepCompare(x, y) {
  let i, l, leftChain, rightChain;

  function compare2Objects(x, y) {
    let p;

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
      return true;
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
      return true;
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if ((typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)) {
      return x.toString() === y.toString();
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
      return false;
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false;
    }

    if (x.constructor !== y.constructor) {
      return false;
    }

    if (x.prototype !== y.prototype) {
      return false;
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
      return false;
    }

    // Quick checking of one object being a subset of another.
    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x[p]) {
        return false;
      }

      switch (typeof (x[p])) {
        case 'object':
        case 'function':

          leftChain.push(x);
          rightChain.push(y);

          if (!compare2Objects(x[p], y[p])) {
            return false;
          }

          leftChain.pop();
          rightChain.pop();
          break;

        default:
          if (x[p] !== y[p]) {
            return false;
          }
          break;
      }
    }

    return true;
  }

  if (arguments.length < 1) {
    return true; //Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = arguments.length; i < l; i++) {

    leftChain = [];
    rightChain = [];

    if (!compare2Objects(arguments[0], arguments[i])) {
      return false;
    }
  }

  return true;
}


/**
 * ajax二进制读取
 * @param useJsonCatch 是否捕获application/json返回并输出异常消息给用户
 */
export async function readBuffer(res, cb, useJsonCatch) {

  if (!res.headers['content-disposition']) {
    console.error("headers['content-disposition'] 不存在")
    console.error('readBuffer', res)
    let errMsg = '下载失败，请重试'
    if (res.headers['content-type'].includes('application/json') && useJsonCatch) {
      const response = new Response(new Blob([res.data]))
      const resJson = await response.json();
      console.log('resJson', resJson)
      resJson.msg ? errMsg = resJson.msg : ''
    }
    Vue.prototype.$message.error(errMsg)
    cb && cb()
    return false
  }
  const fileName = getHeadersFName(res.headers['content-disposition'].split(';'))
  const blob = new Blob([res.data]);
  // 兼容ie createObjectURL
  if ('msSaveOrOpenBlob' in navigator) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return true
  }
  const a = document.createElement('a')
  const bUrl = window.URL.createObjectURL(blob)
  a.download = fileName
  a.href = bUrl
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a);

  // 获取文件名
  function getHeadersFName(conDspAttrs) {
    let fileName = '';
    conDspAttrs.forEach((item, index) => {
      let temp = item.split('=')
      if (temp.length > 1 && temp[0] === 'filename') {
        fileName = decodeURI(temp[1])
      }
    });
    return fileName
  }

  return true
}

/**
 * arrayBuffer 转 json
 */
export function arrayBufferToJson(arrayBuffer) {
  let data = arrayBuffer
  if (arrayBuffer.toString() == "[object ArrayBuffer]") {
    let uint8_msg = new Uint8Array(arrayBuffer);
    // 解码成字符串
    let decodedString = String.fromCharCode.apply(null, uint8_msg);
    // parse,转成json数据
    try {
      data = JSON.parse(decodedString);
    } catch (e) {
      data = decodedString
    }

  }
  return data
}

/**
 * cookie 失效拦截
 */
export function cookieInvalid(err, cb) {
  if (err && err.response && err.response.data) {
    let data = arrayBufferToJson(err.response.data)
    if (data.toString() === "[object Object]" && (data.status == 500 || data.status == 403) && data.data && data.data.gw_code == 401) { // cookie 失效需要重新登录
      if (cb) {
        cb()
      }
      sessionStorage.clear()
      let url = process.env.R_HOST == 'pre' ? api.BASE_URL + '/_stage' : api.BASE_URL + '/tj'
      url = unescape(api.BASE_REDIRECT_URL + '/api/v1/login?redirectUrl=' + window.encodeURIComponent(url) + '&loginParam=brt');
      window.location.href = url
    }
  } else {
    console.log('-------cookieInvalid--------')
  }
}

// URl里面取得对应的key值
export function getUrlKey(name, url) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || ''

}

/**
 * @name   type
 * @time   2019-04-10
 * @param {object}   obj 要检测的对象
 * @description  判断数据类型类型判断
 * @returns {*} 返回boolean值
 */
export function type(obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  return map[toString.call(obj)];
}

/**
 * @param {object} obj 需要克隆的对象
 * @returns {*} 返回克隆对象
 * @description 克隆对象
 */
export function deepClone(obj) {
  const result = type(obj) === 'array' ? [] : {};
  for (const _key in obj) {
    if (_key !== 'children') {
      const _copy = obj[_key];
      if (type(_copy) === 'object') {
        result[_key] = deepClone(_copy);
      } else if (type(_copy) === 'array') {
        result[_key] = deepClone(_copy);
      } else {
        result[_key] = obj[_key];
      }
    }
  }
  return result;
}

/**
 * 查询过滤
 * @param {array}list list
 * @param {function} f 方法
 * @return {*} 返回结果
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * 对象深拷贝
 * @param {object} obj 对象
 * @param {array}cache 缓存
 * @return {*[]|*} 返回拷贝
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  });

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * supportSticky 支持不支持 position: sticky
 * @returns {*} 返回克隆对象
 * @description 克隆对象
 */
export function supportSticky() {
  const vendorList = ['', '-webkit-', '-ms-', '-moz-', '-o-'],
    vendorListLength = vendorList.length,
    stickyElement = document.createElement('div');
  for (let i = 0; i < vendorListLength; i++) {
    stickyElement.style.position = vendorList[i] + 'sticky';
    if (stickyElement.style.position !== '') {
      return true;
    }
  }
  return false;
}


export function exportToSQL(data) {
  // 创建一个Blob实例，类型为文本
  const blob = new Blob([data], {type: 'text/plain;charset=utf-8'});
  // 创建一个指向Blob的URL
  const url = URL.createObjectURL(blob);
  // 创建一个a元素，用于触发下载
  const link = document.createElement('a');
  link.href = url;
  link.download = 'data.sql'; // 设置下载文件名
  // 添加链接到文档并模拟点击
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // 清理URL对象
  URL.revokeObjectURL(url);
}
